const NoMatch = () => {
  return (
    <h3 className="bg-light py-4 text-center">
      <strong>Error 404</strong> - Pagina no encontrada
    </h3>
  );
};
export default NoMatch;
